import React, { Component } from "react";
import moment from 'moment';
import {
    isSimilarObject
} from '../../helper';
import WarningAlert from './WarningAlert';
import defaultImage from '../../images/video_not_found.png';

export default class WorkUploadButton extends Component {

    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    deleteImage(e) {
        e.preventDefault();
        e.stopPropagation();
        this.props.deleteVideoInServer();
    }

    render() {
        const {
            item,
            index,
            btnDisable,
            pictureUploadedLate,
        } = this.props;

        return  (
            <li className="working" key={index}>
                {
                    !btnDisable
                    ?
                    <button
                        className="examples__delete-icon"
                        onClick={this.deleteImage.bind(this)}
                    />
                    : null
                }

                <WarningAlert data={{
                    is_far_away: item.is_far_away,
                    distance_far_away: item.distance_far_away
                }}/>
                
                <div className="img" style={{ backgroundImage: `url(${defaultImage})`}} />
                <div className="title">{`Результат ${index+1}`}</div>
                <div className={`title title-datetime ${pictureUploadedLate ? 'title-datetime-late' : ''}`}>
                    {moment(item.created_at).format("DD.MM.YYYY HH:mm")}
                </div>
            </li>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/WorkIsNotConverted.js